<script setup>
import { computed } from 'vue'
import { buildTree, forEachInTree, MenuItemList } from '@/Components/Navigation'

const value = defineModel()

const createSection = (section) => {
  return computed({
    get() {
      return buildTree(value.value, 'desktop').filter(item => item.viewport?.desktop?.section === section)
    },
    set(updatedItems) {
      forEachInTree(updatedItems, (item, index, parent = null) => {
        value.value[item.id].parent_id = parent ? parent.id : null
        value.value[item.id].viewport.desktop.order = index
        value.value[item.id].viewport.desktop.section = section
      })
    },
  })
}

const left = createSection('left')
</script>

<template>
  <div class="flex flex-col bg-gray-50">
    <div class="w-full bg-gray-100 p-1">Left</div>
    <div v-if="left.length === 0" class="p-3 text-sm text-gray-700 text-center">
      <p>{{ __('No items have been added.') }}</p>
    </div>
    <MenuItemList v-else group="desktop" v-model="left" section="left" />
  </div>
</template>
